module.exports = __webpack_public_path__ + "static/media/left-lane.88e876c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/left-lane.svg
// module id = 2536
// module chunks = 0